import { render, staticRenderFns } from "./ProuniPersonalDocuments.vue?vue&type=template&id=64a7b500&"
import script from "./ProuniPersonalDocuments.vue?vue&type=script&lang=ts&"
export * from "./ProuniPersonalDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports